import firebase from 'firebase/compat';

// Provide a lightweight declaration for `process` so TypeScript in the
// browser build doesn't error when referencing process.env variables.
declare const process: any;

const config = {
    apiKey: "AIzaSyAjXm5aKj8fKzi7nbxT0ad96iqDU2IU6Vs",
    authDomain: "firesafe-beef4.firebaseapp.com",
    projectId: "firesafe-beef4",
    storageBucket: "firesafe-beef4.appspot.com",
    messagingSenderId: "508152839113",
    appId: "1:508152839113:web:d7553f57292d660a660618",
    measurementId: "G-LK7V1TXN52"
};

firebase.initializeApp(config);

export default firebase;
